// Shared display helpers for the mobile app's app_events data (members list, online members,
// session history). The API stores device_type as "ios" / "android" and occurred_at in UTC.

import moment from 'moment'

const PLATFORM_LABELS = { ios: 'iOS', android: 'Android' }

export const formatPlatform = (type) =>
  type ? PLATFORM_LABELS[String(type).toLowerCase()] || type : null

// "v1.4.2 (57)" - either part may be missing.
export const formatBuild = (item) =>
  [item?.app_version && `v${item.app_version}`, item?.build_number && `(${item.build_number})`]
    .filter(Boolean)
    .join(' ')

// "Pixel 8 · Android 15" - used as the device cell's tooltip.
export const formatDeviceDetails = (item) =>
  [item?.device_model, item?.os_version].filter(Boolean).join(' · ')

// app_events timestamps come back as UTC "YYYY-MM-DD HH:mm:ss"; show them in the admin's zone.
export const formatUtcDateTime = (value, format = 'DD.MM.YYYY HH:mm') =>
  value ? moment.utc(value).local().format(format) : '-'
